import React, { useEffect, useState } from "react";
import { Table, TableHead, TableRow, TableCell, TableBody, CircularProgress } from "@material-ui/core";
import {Button} from "../../common/Button/Button"

export default function LoanReadinessTab({ resourcesDetails , addResourcesDetails}) {
    const [sessions, setSessions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (resourcesDetails?.LoanReadiness) {
            setSessions(resourcesDetails.LoanReadiness);
        } else {
            setSessions([]);
        }
        setLoading(false);
    }, [resourcesDetails]);

    console.log(sessions, ">>>>>sessions in gks tab");
    console.log(resourcesDetails, ">>>>resourcesDetails in gks tab ");

    return (
        <div className="p-1">
            {loading ? (
                <CircularProgress />
            ) : sessions.length === 0 ? (
                <p>No sessions available.</p>
            ) : (
                <div className="overflow-auto" style={{ maxHeight: "420px" }}>
                    <Table stickyHeader className="min-w-full">
                        <TableHead style={{ backgroundColor: "#7e1f9a" }}>
                            <TableRow>
                                <TableCell style={{ color: "purple" }}>Instance ID</TableCell>
                                <TableCell style={{ color: "purple" }}>Display Name</TableCell>
                                <TableCell style={{ color: "purple" }}>Category</TableCell>
                                <TableCell style={{ color: "purple" }}>Sector</TableCell>
                                <TableCell style={{ color: "purple" }}>Created</TableCell>
                                <TableCell style={{ color: "purple" }}>Delivered</TableCell>
                                <TableCell style={{ color: "purple" }}>Status</TableCell>
                                <TableCell style={{ color: "purple" }}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {sessions.map((session) => (
                                <TableRow key={session.id} hover>
                                    <TableCell>{session.nResourceInstanceId}</TableCell>
                                    <TableCell>{session.sResourceDisplayName}</TableCell>
                                    <TableCell>{session.sCategory || "—"}</TableCell>
                                    <TableCell>{session.sBusinessSector}</TableCell>
                                    <TableCell>
                                        {session.dtDelivered
                                            ? new Date(session.dtDelivered).toLocaleDateString()
                                            : "—"}
                                    </TableCell>
                                    <TableCell>
                                        {session.dtDelivered
                                            ? new Date(session.dtDelivered).toLocaleDateString()
                                            : "—"}
                                    </TableCell>
                                    <TableCell>{session.refCurrentStateSPM}</TableCell>
                                    <TableCell><Button onClick={()=>addResourcesDetails(4, session.nResourceInstanceId)}>Add Details</Button></TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            )}
        </div>
    );
}
